import Chip from "@mui/material/Chip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import React from "react";
import { useTranslation } from "react-i18next";

export function PriorityCell(props: GridRenderCellParams) {
  const { t } = useTranslation();

  if (props.value === null || props.value === undefined || props.value == -1) return <></>;

  const status = [
    "N/A",
    "Info",
    t("priority.low"),
    t("priority.medium"),
    t("priority.high"),
  ];
  const label = status[props.value] || "N/A";

  const getStyles = (value: number) => {
    switch (value) {
      case 1:
        return { bgcolor: "primary.main", color: "primary.contrastText" };
      case 2:
        return { bgcolor: "rgba(255, 235, 59, 0.75)", color: "#000000" };
      case 3:
        return { bgcolor: "warning.main", color: "warning.contrastText" };
      case 4:
        return { bgcolor: "error.main", color: "error.contrastText" };
      default:
        return { bgcolor: "default", color: "text.primary" };
    }
  };

  const styles = getStyles(props.value || 0);
  return (
    <Chip
      label={label}
      size="small"
      sx={{
        justifyContent: "center",
        fontSize: "0.875rem",
        height: "24px",
        borderRadius: "12px",
        minWidth: "60px",
        maxWidth: "100%",
        margin: "auto",
        backgroundColor: styles.bgcolor,
        color: styles.color,
        "&.MuiChip-root": {
          height: "24px",
        },
      }}
    />
  );
}
